import List from "./list";
import UserPackage from "../models/user_package";
import { excuseApi } from "../commons/http";

export default class UserPackages extends List {
  constructor() {
    super();
    this.total = 0;
  }

  async fetch(page = 1, per_page = 10, params = {}) {
    try {
      const queryParams = {
        page,
        per_page,
        ...params
      };

      // Remove empty/null/undefined values
      Object.keys(queryParams).forEach(key =>
        (queryParams[key] === '' || queryParams[key] === null || queryParams[key] === undefined) && delete queryParams[key]
      );

      const res = await excuseApi({
        path: '/user-packages',
        method: 'GET',
        params: queryParams
      });

      if (res.status === 200) {
        this.clear();
        this.total = res.data.pagination.total;
        this.mapData(res.data.data);
        return true;
      }
      return false;
    } catch (error) {
      throw error;
    }
  }

  mapData(data = []) {
    for (const item of data) {
      const userPackage = new UserPackage(item);
      this.add(userPackage);
    }
  }
}
